import { render, staticRenderFns } from "./howItWorks.vue?vue&type=template&id=9a8d6e5e&scoped=true&"
import script from "./howItWorks.vue?vue&type=script&lang=js&"
export * from "./howItWorks.vue?vue&type=script&lang=js&"
import style0 from "./howItWorks.vue?vue&type=style&index=0&id=9a8d6e5e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8d6e5e",
  null
  
)

export default component.exports